import { atom } from 'jotai'

import { currentEnv } from '@/env/vars.ts'
import { widgetsConfig } from '@/pages/components/tasksApprovals/config'
import { queryClient } from '@/QueryClient'
import { store } from '@/store'
import { IWidgetSettings } from '@/types/tasksApprovals'
import { GET } from '@/utils/fetch'

export const widgetsAtom = atom<IWidgetSettings[]>([])

export const getWidgets = async () => {
    const res = await queryClient.fetchQuery({
        queryKey: ['widgets'],
        queryFn: () => GET<IWidgetSettings[]>(`${currentEnv.approvalsUrl}/settings`),
    })

    if (res) {
        // Merge info from API with local info
        const widgets = res.map((widget) => {
            const _widget = {
                ...widget,
                ...widgetsConfig(widget.system),
            }
            return _widget
        })

        store.set(widgetsAtom, widgets)
    }
}
